import React, { useState, useEffect } from "react";
import { FaDollarSign } from "react-icons/fa";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input'


export default function CostCenterPopUp(props) {
    const [nome, setNome] = useState(props.costCenter && props.costCenter.nome ? props.costCenter.nome : "");

    useEffect(() => {
        if(props.costCenter && Object.keys(props.costCenter).length > 0) {
            setNome(props.costCenter.nome);
        }
    }, [props.costCenter]);

    return (
        <Popup
            icon = {<FaDollarSign/>}
            tittle = {props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >

            <Input
                label="Nome*"
                placeholder="Digite o nome do centro de custo"
                //type="textarea"
                id="new-cost-center-popup-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <button onClick={() => props.onClick({nome})}>{props.buttonTittle}</button>
        
        </Popup>
)
}